import Request from ".";
import { Routes } from "../constant/api_url";

const insertPaymentMethodApi = async (data) => {
  try {
    const result = await Request.post(Routes.INSERTPAYMENTMETHOD, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const updatePaymentMethodApi = async (data) => {
  try {
    const result = await Request.post(Routes.UPDATEPAYMENTMETHOD, data, {
      headers: {
        Accept: "application/json , */*",
        "Content-Type": "application/json"
      }
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

const getPaymentMethodApi = async () => {
  try {
    const result = await Request.get(Routes.GETPAYMENTMETHOD);
    return result.data;
  } catch (error) {
    throw error;
  }
};

const deletePaymentMethodApi = async (data) => {
  try {
    const result = await Request.delete(Routes.DELETEPAYMENTMETHOD, { data });
    return result.data;
  } catch (error) {
    throw error;
  }
};

export {
  insertPaymentMethodApi,
  updatePaymentMethodApi,
  getPaymentMethodApi,
  deletePaymentMethodApi
};
